"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SubmitLineItem_1 = __importDefault(require("./SubmitLineItem"));
class SubmitContentItem {
    constructor(data) {
        if (data) {
            Object.assign(this, data);
        }
        else {
            this.type = "ltiResourceLink";
            this.title = "Title";
            this.url = "/assignment?assignmentId=tool-assignment-xyz";
            this.resourceId = "tool-assignment-xyz";
            this.lineItem = new SubmitLineItem_1.default(null);
        }
    }
}
exports.default = SubmitContentItem;
